import { Box, Container, Image, Stack, Text, Flex, Avatar } from "@chakra-ui/react";
import React from "react";
import { withTranslation } from "react-i18next";
import { FaStar } from "react-icons/fa";

const Testimonials = ({ t }) => {
  const testimonials = [
    {
      name: "أحمد محمد",
      role: "طالب في الصف الثالث الثانوي",
      content: "منصة أسكيرا غيرت طريقة دراستي تماماً. المحتوى واضح والشرح ممتاز!",
      rating: 5,
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face"
    },
    {
      name: "فاطمة علي",
      role: "طالبة في الصف الثاني الثانوي",
      content: "الملخصات والتمارين ساعدتني كثيراً في فهم المواد الصعبة. أنصح بها بشدة!",
      rating: 5,
      avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face"
    },
    {
      name: "محمد حسن",
      role: "طالب في الصف الأول الثانوي",
      content: "الجلسات المباشرة مع المدرسين ممتازة. يمكنني طرح الأسئلة والحصول على إجابات فورية.",
      rating: 5,
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face"
    }
  ];

  return (
    <Container maxW={"container.xl"} my="8rem" id="testimonials">
      <Text
        textAlign="center"
        fontWeight="500"
        fontSize={{ base: "20px", md: "25px" }}
        mb={3}
      >
        {t("components.testimonials.title") || "آراء طلابنا"}{" "}
        <Image src={require("../../../assets/line.jpg")} m="auto" mt={3} />
      </Text>

      <Stack 
        direction={{ base: "column", md: "row" }} 
        gap={6} 
        mt={12}
        align="stretch"
      >
        {testimonials.map((testimonial, index) => (
          <Box
            key={index}
            bg="white"
            borderRadius="24px"
            p={8}
            boxShadow="0 10px 30px rgba(0,0,0,0.1)"
            border="1px solid"
            borderColor="gray.100"
            transition="all 0.3s ease"
            _hover={{
              transform: "translateY(-8px)",
              boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
              borderColor: "blue.200"
            }}
            position="relative"
            overflow="hidden"
            flex="1"
          >
            {/* Background decoration */}
            <Box
              position="absolute"
              top="-30px"
              right="-30px"
              w="120px"
              h="120px"
              bg="blue.50"
              borderRadius="full"
              opacity="0.1"
            />
            
            {/* Rating stars */}
            <Flex mb={4} gap={1}>
              {[...Array(testimonial.rating)].map((_, i) => (
                <FaStar key={i} color="#FFD700" fontSize="18px" />
              ))}
            </Flex>

            {/* Testimonial content */}
            <Text 
              fontSize="16px" 
              color="gray.700" 
              lineHeight="1.8" 
              mb={6}
              fontStyle="italic"
            >
              "{testimonial.content}"
            </Text>

            {/* Author info */}
            <Flex align="center" gap={4}>
              <Avatar
                src={testimonial.avatar}
                name={testimonial.name}
                size="md"
                border="3px solid"
                borderColor="blue.100"
              />
              <Box>
                <Text fontSize="16px" fontWeight="700" color="gray.800">
                  {testimonial.name}
                </Text>
                <Text fontSize="14px" color="gray.600">
                  {testimonial.role}
                </Text>
              </Box>
            </Flex>
          </Box>
        ))}
      </Stack>
    </Container>
  );
};

export default withTranslation()(Testimonials);

